import {
    EmojiReactionWithInfo,
    EmojiReactionGroup,
} from '@/common/types/commonTypes';

/**
 * 이모지 리액션을 이모지 코드별로 그룹화하고 등록 시간순으로 정렬
 *
 * 1. 동일한 이모지 코드별로 리액션을 그룹화하여 사용자 목록 생성
 * 2. 각 그룹에서 가장 오래된 등록 날짜를 저장
 * 3. 가장 오래된 등록 날짜 기준으로 오름차순 정렬 (오래된 것이 먼저)
 *
 * @param reactions 원본 이모지 리액션 목록
 * @returns 이모지별로 그룹화되고 등록 시간순으로 정렬된 리액션 그룹 배열
 */
export function groupAndSortEmojiReactions(
    reactions: EmojiReactionWithInfo[]
): EmojiReactionGroup[] {
    const grouped: Record<string, EmojiReactionGroup> = {};

    reactions?.forEach(reaction => {
        if (!grouped[reaction.emoji_code]) {
            grouped[reaction.emoji_code] = {
                emoji_code: reaction.emoji_code,
                users: [],
                register_date: reaction.register_date,
            };
        } else {
            // 더 오래된 register_date가 있으면 업데이트
            const currentDate = new Date(
                grouped[reaction.emoji_code].register_date
            );
            const newDate = new Date(reaction.register_date);
            if (newDate < currentDate) {
                grouped[reaction.emoji_code].register_date =
                    reaction.register_date;
            }
        }

        grouped[reaction.emoji_code].users.push(reaction.user);
    });

    // register_date 기준으로 오름차순 정렬 (오래된 순)
    return Object.values(grouped).sort(
        (a, b) =>
            new Date(a.register_date).getTime() -
            new Date(b.register_date).getTime()
    );
}
